import React, { useState, useEffect } from "react";
import {
  Userlogin,
  GetDealerdata,
  Toast,
  fetchDataFromApi,
  shareIphonePostMsg,
  DateFormate,
} from "../../Utils/general-function";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../../Header";
import Loader from "../../Utils/Loader";
import Search from "../../Search";
import QRCode from "qrcode.react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import CatlogueHeader from "../CatlogueHeader";
import { RWebShare } from "react-web-share";
import Innerlistcommon from "./Innerlistcommon";
import NoCars from "../../Utils/NoCars";

function Catlogue(props) {
  const [catloguelist, setCatloguelist] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [originalList, setOriginalList] = useState([]);
  const [apiData, setapiData] = useState({});
  let params = useParams();
  console.log("params catlogue", params);

  const iphone = window.navigator.userAgent.includes("Mac");

  useEffect(() => {
    const fetchdata = async () => {
      if (!Userlogin()) {
        navigate("/Login");
        return;
      }
      try {
        GetDealerdata().then((res) => {
          setapiData(res);
        });
        const catloguedata = await fetchDataFromApi(
          "/api/CarCateloge/AllCatelogebycarnoDealerid?carno=0&carstatus=Catlogue",
        );
        if (
          catloguedata.Message ===
          "Authorization has been denied for this request."
        ) {
          localStorage.clear();
          navigate("/Login");
          return;
        }
        setCatloguelist(catloguedata.Data);
        setOriginalList(catloguedata.Data);
        setLoading(false);
      } catch (error) {
        console.log("error from catalog", error);
      }
    };
    fetchdata();
  }, [navigate, params.id]);

  const handleCallback = (childData) => {
    setLoading(true);
    setCatloguelist(childData);
    setLoading(false);
  };

  const GenerateQr = async () => {
    setLoading(true);
    // debugger

    const min = 1;
    const max = 500;
    const rand = parseInt(min + Math.random() * (max - min));
    const canvas1 = await document.getElementById("print");
    canvas1.style.display = "block";
    try {
      html2canvas(canvas1).then((canvas) => {
        const pngUrl = canvas.toDataURL("image/png");
        const pdf = new jsPDF();
        pdf.addImage(pngUrl, "PNG", 12.3, 0, 185, 291, "", "SLOW");

        if (iphone) {
          const bs64 = pdf.output("datauristring");
          setLoading(false);
          return shareIphonePostMsg({
            data: bs64,
            filename: "Catalog_QR" + rand + ".pdf",
            action: "sharebase64",
          });
        }

        pdf.save("Catalog_QR" + rand);
        setLoading(false);
        Toast(true, "Qr generated Successfully", "");
      });
    } catch (e) {
      Toast(false, "", e);
    }

    canvas1.style.display = "none";
  };

  // console.log("olist", originalList);

  const callbackCatloguelist = (obj) => {
    // purpose: fire when unsold car from catalogue
    setCatloguelist(obj?.catloguelists); // filtered car from catalogue list and these catalogue list will be show

    let filterdOriginal = originalList.filter(
      (list) => list?.carnumber !== obj?.targetedsoldcar?.carnumber,
    ); // removed the sold car from orginal list so never show sold car to user again on searching etc

    setOriginalList(filterdOriginal);
  };

  return (
    <div>
      {loading ? <Loader /> : null}
      <Header />
      <div className="text-end pt-3 pe-2">
        <button
          onClick={(e) => GenerateQr()}
          className="sharebtn sharbtnpos"
          style={{ padding: "0 0 0 8px" }}
        >
          QR Code
          <span style={{ marginLeft: "9px" }}>
            <img src="/assets/images/qr-white.png" alt="" />
          </span>
        </button>
      </div>

      <CatlogueHeader Datafromparent={apiData} />

      <div className="page-space">
        <Search dataFromParent={originalList} parentCallback={handleCallback} />

        <div
          className="gap-2 mb-3 justify-content-between w-100"
          style={{
            overflowX: "scroll",
            scrollbarWidth: "none",
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
          }}
        >
          <Link
            to="/Specifiedcarcatlogue"
            className="d-flex align-items-center gap-2 border-1 flex-shrink-0"
            style={{
              borderRadius: "6px",
              borderColor: "red",
              fontWeight: "400",
              fontSize: "14px",
              backgroundColor: "#ffd0d0",
              border: "1px solid red",
            }}
          >
            <span className="material-symbols-outlined fw-4 ms-2 text-danger">
              directions_car
            </span>
            Model Wise Catalog {">"}
          </Link>
          <Link
            to="/gearwisecatalog"
            className="d-flex align-items-center gap-2  border-1 flex-shrink-0"
            style={{
              borderRadius: "6px",
              // borderColor: "red",
              fontWeight: "400",
              fontSize: "14px",
              backgroundColor: "#ffd0d0",
              border: "1px solid red",
            }}
          >
            <span className="material-symbols-outlined fw-4 ms-2 text-danger">
              auto_transmission
            </span>{" "}
            Gear Wise Catalog {">"}
          </Link>

          <Link
            to="/fuelwisecatalog"
            className="d-flex align-items-center gap-2  border-1 flex-shrink-0"
            style={{
              borderRadius: "6px",
              fontWeight: "400",
              fontSize: "14px",
              backgroundColor: "#ffd0d0",
              border: "1px solid red",
            }}
          >
            <span className="material-symbols-outlined fw-4 ms-2 text-danger">
              local_gas_station
            </span>
            Fuel Wise Catalog {">"}
          </Link>
          {catloguelist.length === 0 ? null : iphone ? (
            <button
              className="d-flex align-items-center gap-2  border-1 flex-shrink-0"
              style={{
                borderRadius: "6px",
                fontWeight: "400",
                fontSize: "14px",
                backgroundColor: "#ffd0d0",
                border: "1px solid red",
              }}
              onClick={() => {
                shareIphonePostMsg({
                  url:
                    "https://m.carthi.in/#/Catlogueshare/" +
                    apiData.DealerRand +
                    "/" +
                    apiData.Firmname,
                  action: "urlshare",
                });
              }}
            >
              <span className="material-symbols-outlined fw-4 text-danger">
                share
              </span>
              Share All Car
            </button>
          ) : (
            <RWebShare
              data={{
                text: "",
                url:
                  "https://m.carthi.in/#/Catlogueshare/" +
                  apiData.DealerRand +
                  "/" +
                  apiData.Firmname,
                title: apiData.Firmname,
              }}
              onClick={() => console.log("shared successfully!")}
            >
              <button
                className="d-flex align-items-center gap-2  border-1 flex-shrink-0"
                style={{
                  borderRadius: "6px",
                  fontWeight: "400",
                  fontSize: "14px",
                  backgroundColor: "#ffd0d0",

                  border: "1px solid red",
                }}
              >
                <span className="material-symbols-outlined fw-4 text-danger">
                  share
                </span>
                Share All Car
              </button>
            </RWebShare>
          )}
        </div>
        {/* <div
          className="d-flex gap-2 mb-3 justify-content-between w-100"
          style={{ overflowX: "scroll", scrollbarWidth: "none" }}
        >
          <button
            className="d-flex align-items-center gap-2   border-1 flex-shrink-0"
            style={{
              borderRadius: "6px",
              borderColor: "red",
              fontWeight: "400",
              fontSize: "14px",
              backgroundColor: "#ffd0d0",
              // color: "var(--prcolor)",
              border: "1px solid red",
            }}
          >
            <span className="material-symbols-outlined fw-4 text-danger">
              directions_car
            </span>
            <Link to="/Specifiedcarcatlogue">Model Wise Catalog {">"}</Link>
          </button>
          <button
            className="d-flex align-items-center gap-2  border-1 flex-shrink-0"
            style={{
              borderRadius: "6px",
              // borderColor: "red",
              fontWeight: "400",
              fontSize: "14px",
              backgroundColor: "#ffd0d0",

              border: "1px solid red",
            }}
          >
            <span className="material-symbols-outlined fw-4 text-danger">
              auto_transmission
            </span>
            <Link to="/gearwisecatalog" className="text-black">
              {" "}
              Gear Wise Catalog {">"}
            </Link>
          </button>
          <button
            className="d-flex align-items-center gap-2  border-1 flex-shrink-0"
            style={{
              borderRadius: "6px",
              fontWeight: "400",
              fontSize: "14px",
              backgroundColor: "#ffd0d0",

              border: "1px solid red",
            }}
          >
            <span className="material-symbols-outlined fw-4 text-danger">
              local_gas_station
            </span>
            <Link to="/fuelwisecatalog" className="text-black">
              {" "}
              Fuel Wise Catalog {">"}
            </Link>
          </button>
        </div> */}
        {catloguelist.length === 0 ? (
          <NoCars />
        ) : (
          <>
            <Innerlistcommon
              catloguelist={catloguelist}
              onDataChangeProp={callbackCatloguelist} // fire when car unsold from catalogue
              scrollKey="myCatalogueScrollPosition"
              from={`Catlogue/${params?.id}`}
            />
            {/* <ScrollButton/> */}
            {/* <div className="fixshare">
              {catloguelist.length === 0 ? null : iphone ? (
                <button
                  className="sharebtn"
                  onClick={() => {
                    shareIphonePostMsg({
                      url:
                        "https://m.carthi.in/#/Catlogueshare/" +
                        apiData.DealerRand +
                        "/" +
                        apiData.Firmname,
                      action: "urlshare",
                    });
                  }}
                >
                  Share All Car
                  <span>
                    <img src="assets/images/share.png" alt="" />
                  </span>
                </button>
              ) : (
                <RWebShare
                  data={{
                    text: "",
                    url:
                      "https://m.carthi.in/#/Catlogueshare/" +
                      apiData.DealerRand +
                      "/" +
                      apiData.Firmname,
                    title: apiData.Firmname,
                  }}
                  onClick={() => console.log("shared successfully!")}
                >
                  <button className="sharebtn">
                    Share All Car
                    <span>
                      <img src="assets/images/share.png" alt="" />
                    </span>
                  </button>
                </RWebShare>
              )}
            </div> */}
          </>
        )}
        <div id="print" style={{ display: "none" }} className="div_print">
          <div className="qrdiv">
            <h2
              style={{
                fontSize: "30px",
                lineHeight: "40px",
                fontWeight: "600",
                marginBottom: "50px",
              }}
            >
              Scan QR
            </h2>
            <QRCode
              value={
                "https://m.carthi.in/#/Catlogueshare/" +
                apiData.DealerRand +
                "/" +
                apiData.Firmname
              }
              size={290}
              level={"H"}
              includeMargin={true}
            />
            {/* <h2
                    style={{
                      fontSize: "30px",
                      lineHeight: "40px",
                      fontWeight: "600",
                      marginTop: " 30px",
                    }}
                  >
                    {list.carnumber}
                  </h2> */}
            <div style={{ marginTop: "50px" }}>
              <h3
                style={{
                  fontSize: "24px",
                  lineHeight: "34px",
                  fontWeight: "500",
                }}
              >
                {apiData.Firmname}
              </h3>
              <h3
                style={{
                  fontSize: "24px",
                  lineHeight: "34px",
                  fontWeight: "500",
                }}
              >
                {apiData.Mobileno}
              </h3>
            </div>
            <img src="assets/images/scissors.png" className="scissors" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Catlogue;

// old but with new changes like edit button and ownern name
// import React, { useState, useEffect } from "react";
// import {
//   Userlogin,
//   GetDealerdata,
//   Toast,
//   fetchDataFromApi,
//   shareIphonePostMsg,
//   DateFormate,
// } from "../../Utils/general-function";
// import { Link, useNavigate, useParams } from "react-router-dom";
// import Header from "../../Header";
// import Loader from "../../Utils/Loader";
// import Search from "../../Search";
// import QRCode from "qrcode.react";
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";
// import CatlogueHeader from "../CatlogueHeader";
// import { RWebShare } from "react-web-share";
// import Innerlistcommon from "./Innerlistcommon";
// import NoCars from "../../Utils/NoCars";

// function Catlogue(props) {
//   const [catloguelist, setCatloguelist] = useState([]);
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(true);
//   const [originalList, setOriginalList] = useState([]);
//   const [apiData, setapiData] = useState({});
//   let params = useParams();
//   const iphone = window.navigator.userAgent.includes("Mac");

//   useEffect(() => {
//     const fetchdata = async () => {
//       if (!Userlogin()) {
//         navigate("/Login");
//         return;
//       }
//       try {
//         GetDealerdata().then((res) => {
//           setapiData(res);
//         });
//         const catloguedata = await fetchDataFromApi(
//           "/api/CarCateloge/AllCatelogebycarnoDealerid?carno=0&carstatus=Catlogue"
//         );
//         if (
//           catloguedata.Message ===
//           "Authorization has been denied for this request."
//         ) {
//           localStorage.clear();
//           navigate("/Login");
//           return;
//         }
//         setCatloguelist(catloguedata.Data);
//         setOriginalList(catloguedata.Data);
//         setLoading(false);
//       } catch (error) {
//         console.log("error from catalogue", error);
//       }
//     };
//     fetchdata();
//   }, [navigate, params.id]);

//   const handleCallback = (childData) => {
//     setLoading(true);
//     setCatloguelist(childData);
//     setLoading(false);
//   };

//   const GenerateQr = async () => {
//     setLoading(true);
//     // debugger

//     const min = 1;
//     const max = 500;
//     const rand = parseInt(min + Math.random() * (max - min));
//     const canvas1 = await document.getElementById("print");
//     canvas1.style.display = "block";
//     try {
//       html2canvas(canvas1).then((canvas) => {
//         const pngUrl = canvas.toDataURL("image/png");
//         const pdf = new jsPDF();
//         pdf.addImage(pngUrl, "PNG", 12.3, 0, 185, 291, "", "SLOW");

//         if (iphone) {
//           const bs64 = pdf.output("datauristring");
//           setLoading(false);
//           return shareIphonePostMsg({
//             data: bs64,
//             filename: "Catalogue_QR" + rand + ".pdf",
//             action: "sharebase64",
//           });
//         }

//         pdf.save("Catalogue_QR" + rand);
//         setLoading(false);
//         Toast(true, "Qr generated Successfully", "");
//       });
//     } catch (e) {
//       Toast(false, "", e);
//     }

//     canvas1.style.display = "none";
//   };

//   // console.log("olist", originalList);

//   const callbackCatloguelist = (obj) => {
//     // purpose: fire when unsold car from catalogue
//     setCatloguelist(obj?.catloguelists); // filtered car from catalogue list and these catalogue list will be show

//     let filterdOriginal = originalList.filter(
//       (list) => list?.carnumber !== obj?.targetedsoldcar?.carnumber
//     ); // removed the sold car from orginal list so never show sold car to user again on searching etc

//     setOriginalList(filterdOriginal);
//   };

//   return (
//     <div>
//       {loading ? <Loader /> : null}
//       <Header />
//       <div className="text-end pt-3 pe-2">
//         <button
//           onClick={(e) => GenerateQr()}
//           className="sharebtn sharbtnpos"
//           style={{ padding: "0 0 0 8px" }}
//         >
//           QR Code
//           <span style={{ marginLeft: "9px" }}>
//             <img src="/assets/images/qr-white.png" alt="" />
//           </span>
//         </button>
//       </div>

//       <CatlogueHeader Datafromparent={apiData} />

//       <div className="page-space" style={{ marginBottom: "56px" }}>
//         <Search dataFromParent={originalList} parentCallback={handleCallback} />
//         {catloguelist.length === 0 ? (
//           <NoCars />
//         ) : (
//           <>
//             <Innerlistcommon
//               catloguelist={catloguelist}
//               onDataChangeProp={callbackCatloguelist} // fire when car unsold from catalogue
//             />
//             {/* <ScrollButton/> */}
//             <div className="fixshare fixshareResp">
//               <div className="sharebtn">
//                 <Link to="/Specifiedcarcatlogue" className="tx-white">
//                   Model Wise Catalog
//                 </Link>
//                 <span>
//                   <img src="assets/images/share.png" alt="" />
//                 </span>
//               </div>
//               {catloguelist.length === 0 ? null : iphone ? (
//                 <button
//                   className="sharebtn"
//                   onClick={() => {
//                     shareIphonePostMsg({
//                       url:
//                         "https://m.carthi.in/#/Catlogueshare/" +
//                         apiData.DealerRand +
//                         "/" +
//                         apiData.Firmname,
//                       action: "urlshare",
//                     });
//                   }}
//                 >
//                   Share All Car
//                   <span>
//                     <img src="assets/images/share.png" alt="" />
//                   </span>
//                 </button>
//               ) : (
//                 <RWebShare
//                   data={{
//                     text: "",
//                     url:
//                       "https://m.carthi.in/#/Catlogueshare/" +
//                       apiData.DealerRand +
//                       "/" +
//                       apiData.Firmname,
//                     title: apiData.Firmname,
//                   }}
//                   onClick={() => console.log("shared successfully!")}
//                 >
//                   <button className="sharebtn">
//                     Share All Car
//                     <span>
//                       <img src="assets/images/share.png" alt="" />
//                     </span>
//                   </button>
//                 </RWebShare>
//               )}
//             </div>
//           </>
//         )}
//         <div id="print" style={{ display: "none" }} className="div_print">
//           <div className="qrdiv">
//             <h2
//               style={{
//                 fontSize: "30px",
//                 lineHeight: "40px",
//                 fontWeight: "600",
//                 marginBottom: "50px",
//               }}
//             >
//               Scan QR
//             </h2>
//             <QRCode
//               value={
//                 "https://m.carthi.in/#/Catlogueshare/" +
//                 apiData.DealerRand +
//                 "/" +
//                 apiData.Firmname
//               }
//               size={290}
//               level={"H"}
//               includeMargin={true}
//             />
//             {/* <h2
//                     style={{
//                       fontSize: "30px",
//                       lineHeight: "40px",
//                       fontWeight: "600",
//                       marginTop: " 30px",
//                     }}
//                   >
//                     {list.carnumber}
//                   </h2> */}
//             <div style={{ marginTop: "50px" }}>
//               <h3
//                 style={{
//                   fontSize: "24px",
//                   lineHeight: "34px",
//                   fontWeight: "500",
//                 }}
//               >
//                 {apiData.Firmname}
//               </h3>
//               <h3
//                 style={{
//                   fontSize: "24px",
//                   lineHeight: "34px",
//                   fontWeight: "500",
//                 }}
//               >
//                 {apiData.Mobileno}
//               </h3>
//             </div>
//             <img src="assets/images/scissors.png" className="scissors" alt="" />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Catlogue;
